import { render, staticRenderFns } from "./ProblemChangelog.vue?vue&type=template&id=4448ea54&scoped=true"
import script from "./ProblemChangelog.vue?vue&type=script&lang=js"
export * from "./ProblemChangelog.vue?vue&type=script&lang=js"
import style0 from "./ProblemChangelog.vue?vue&type=style&index=0&id=4448ea54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4448ea54",
  null
  
)

export default component.exports